export default function OpenItems() {
  return (
    <section className="sales-layout__page">
      <h1>Posten</h1>
      <p>Die Posten sind in Vorbereitung.</p>
    </section>
  );
}
